import { useIxcRegistrationV1AccountQueryServiceAccountGet } from '@interxfi/api-client/generated/hooks/ixc-registration-v1-account-query-service-account-get';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';

interface AccountBreadcrumbProps {
  accountId: string;
  displayIdOnly?: boolean;
}

export function AccountBreadcrumb({ accountId, displayIdOnly }: AccountBreadcrumbProps) {
  const { data, error, isPending } = useIxcRegistrationV1AccountQueryServiceAccountGet({ accountId });
  const showPending = Boolean(isPending || error);
  if (showPending) {
    return <Skeleton charCount={8} />;
  }

  if (displayIdOnly) {
    return data?.account?.data?.displayId || data?.account?.accountId || 'Account';
  }

  return ['Account', data?.account?.accountId].filter(Boolean).join(' ');
}
